import { useEffect, useState } from 'react';
import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export const ALL_FEE_INVOICES_LIMIT = 500;

// Alle Tippi-gebyrfakturaer (kind: 'tippi-fee') for admin, nyeste først.
// Egen spørring, så gebyrene ikke fortrenges av andre fakturatyper av grensen.
export function useAllFeeInvoices() {
  const [invoices, setInvoices]   = useState([]);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);
  const [truncated, setTruncated] = useState(false);

  useEffect(() => {
    const q = query(
      collection(db, 'invoices'),
      where('kind', '==', 'tippi-fee'),
      orderBy('createdAt', 'desc'),
      limit(ALL_FEE_INVOICES_LIMIT),
    );
    return onSnapshot(q, snap => {
      setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setTruncated(snap.docs.length >= ALL_FEE_INVOICES_LIMIT);
      setError(null);
      setLoading(false);
    }, err => {
      console.error('useAllFeeInvoices:', err);
      setInvoices([]);
      setTruncated(false);
      setError(err);
      setLoading(false);
    });
  }, []);

  return { invoices, loading, error, truncated };
}
